export const assemblyListHd=[
    { id:'asset_type', label: 'Major Assembly', sortOption: false },
    { id:'lessor_name', label: 'Assigned MSN', sortOption: false },
    { id:'owner_name', label: 'Lease Start Date', sortOption: false },
    { id:'owner_name', label: 'Lease End Date', sortOption: false },
    { id:'lessee_id', label: 'Lease Status', sortOption: false },
]